import { CompanyStatuses } from '@/constants/companies';
import get from 'lodash/get';

let canAccess: Boolean;
export const clearCache = () => {
  canAccess = false;
};

// Requires a paying company
// Catalog is always enabled (allows employees/managers to browse and request training)
const canAccessTrainingModule = async (
  userId: String,
  store
): Promise<Boolean> => {
  if (canAccess) {
    return true;
  }

  const { currentUser } = store.getters;
  const companyStatus = get(currentUser, '_company.status');

  const isCompanyPaying = companyStatus === CompanyStatuses.PAYING;
  const isTrial = companyStatus === CompanyStatuses.TRIAL;

  if (!isCompanyPaying && !isTrial) {
    return false;
  }

  // Catalog is always enabled - all paying/trial companies can access training
  canAccess = true;

  return canAccess;
};

export default canAccessTrainingModule;
